/**
 * One queue pass at a time. A pass requested while one runs makes it loop
 * once more, so updates merged in meanwhile go out as one follow-up request.
 */
export class SyncQueueRunner {
  private active?: Promise<void>;
  private rerun = false;

  public run(pass: () => Promise<void>): Promise<void> {
    if (this.active) {
      this.rerun = true;
      return this.active;
    }

    this.active = (async () => {
      try {
        do {
          this.rerun = false;
          await pass();
        } while (this.rerun);
      } finally {
        this.active = undefined;
      }
    })();

    return this.active;
  }
}
